import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import app from "./modules/app";
import settings from "./modules/settings";
import user from "./modules/user";
import render from "./modules/render";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    render
  },
  getters
  // state: {
  //   organization: [] //组织列表
  // },
  // mutations: {
  //   SET_BRANCH(state, payload) {
  //     console.log("0", payload);
  //     state.organization = payload;
  //   }
  // },
  // actions: {
  //   BRANCHLIST({ commit }, payload) {
  //     this.$axios
  //       .post(
  //         this.$server + "/depart/branchListNew",
  //         this.$qs.stringify({
  //           page: 1,
  //           rows: 10000
  //         })
  //       )
  //       .then(res => {
  //         console.log("2", res);
  //         if (res.data.code == "0") {
  //           // this.loading = false;
  //           // this.organization = res.data.data.map(v => {
  //           //   return { label: v.departName, value: v.departId };
  //           // });
  //           commit("SET_BRANCH", res.data.data);
  //         } else {
  //           this.$message.error(res.data.message);
  //         }
  //       });
  //   }
  // }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js